export default "__VITE_ASSET__39625428__"